import { useQuery } from "@tanstack/react-query";
import { getCustomer } from "../api/customer";
import { GetMemberParams } from "../types/types";
const useGetCustomer = ({
  page,
  searchKey,
  area,
  sort,
  limit,
  groupId,
}: GetMemberParams) => {
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: [
      "Customer",
      `page-${page}`,
      `searchKey-${searchKey}`,
      `area-${area}`,
      `sort-${sort}`,
      `limit-${limit}`,
      `groupId-${groupId}`,
    ],
    queryFn: () =>
      getCustomer({ page, searchKey, area, sort, limit, groupId }),
    retry: false,
    staleTime: 0,
    refetchOnWindowFocus: false,
    // onSuccess: (data) => {
    //   return data;
    // },
    // onError: (error: AxiosError) => {
    //   return error;
    // },
  });

  return { data, isLoading, isSuccess };
};

export default useGetCustomer;
